import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
} from '../grid/iLocalAGGrid';

/**
 * Compact AG Grid SSRM list for dashboard cards (Locations, Live Agents).
 * Parent mutates filterBody in place and calls refresh() after search changes.
 */
class DashboardListGrid extends Component {
  gridApi = null;

  componentDidUpdate(prevProps) {
    if (prevProps.refreshKey !== this.props.refreshKey && this.gridApi) {
      if (typeof this.gridApi.refreshServerSideStore === 'function') {
        this.gridApi.refreshServerSideStore({ purge: true });
      } else if (typeof this.gridApi.refreshServerSide === 'function') {
        this.gridApi.refreshServerSide({ purge: true });
      }
    }
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    const {
      filterBody,
      fetchPage,
      pageZeroBased = false,
      onTotal,
      applyFilterModel,
      sortMap,
    } = this.props;

    const datasource = createServerSideDatasource({
      fetchPage,
      filterBody,
      pageZeroBased,
      applyFilterModel,
      sortMap,
      onSuccess: (results, total) => {
        if (onTotal) onTotal(total);
      },
    });

    if (typeof params.api.setServerSideDatasource === 'function') {
      params.api.setServerSideDatasource(datasource);
    }

    if (this.props.onGridReady) {
      this.props.onGridReady(params);
    }
  };

  render() {
    const {
      columnDefs,
      cacheBlockSize = 20,
      paginationPageSize = 20,
      getRowId,
      height = 420,
      rowHeight = 48,
    } = this.props;

    return (
      <Box sx={{ width: '100%' }}>
        <ILocalAGGrid
          columnDefs={columnDefs}
          defaultColDef={getDefaultColDef({
            minWidth: 100,
            flex: 1,
          })}
          rowModelType="serverSide"
          cacheBlockSize={cacheBlockSize}
          paginationPageSize={paginationPageSize}
          paginationPageSizeSelector={[10, 20, 25]}
          rowHeight={rowHeight}
          gridHeight={height}
          domLayout="normal"
          onGridReady={this.onGridReady}
          getRowId={getRowId}
          overlayNoRowsTemplate="No data found"
        />
      </Box>
    );
  }
}

DashboardListGrid.propTypes = {
  columnDefs: PropTypes.array.isRequired,
  filterBody: PropTypes.object.isRequired,
  fetchPage: PropTypes.func.isRequired,
  pageZeroBased: PropTypes.bool,
  onTotal: PropTypes.func,
  applyFilterModel: PropTypes.func,
  sortMap: PropTypes.object,
  cacheBlockSize: PropTypes.number,
  paginationPageSize: PropTypes.number,
  getRowId: PropTypes.func,
  height: PropTypes.number,
  rowHeight: PropTypes.number,
  refreshKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onGridReady: PropTypes.func,
};

export default DashboardListGrid;



// WEBPACK FOOTER //
// ./src/components/dashboard2/DashboardListGrid.js